import { useDisclosure } from "@chakra-ui/react";
import { useCallback, useState } from "react";

/**
 * Similar to `useDisclosure`, but it also maintains a 'mode', allowing you to
 * open into a specific `mode` using `onOpen`.
 *
 * Use this when opening a component that has multiple modes/ configurations.
 */
export function useModeDisclosure<T extends string>(initialMode: T) {
  const { isOpen, onClose, onOpen: disclosureOnOpen } = useDisclosure();
  const [mode, setMode] = useState<T>(initialMode);

  const onOpen = useCallback(
    (mode: T) => {
      setMode(mode);
      disclosureOnOpen();
    },
    [disclosureOnOpen],
  );

  return {
    isOpen,
    onOpen,
    onClose,
    mode,
  };
}
